import React, { useMemo } from 'react';
import Select, { components } from 'react-select';
import { useSelector } from 'react-redux';
import { selectFormSearchOptions } from '@redux/selectors/FormSelector';

const formatGroupLabel = () => (
  <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }} />
);

const DropdownIndicator = props => (
  <components.DropdownIndicator {...props}>
    <button type="button" className="btn btn-primary" style={{ borderTopLeftRadius: 0, borderBottomLeftRadius: 0, marginLeft: '8px' }}>
      <i className="fas fa-search" />
    </button>
  </components.DropdownIndicator>
);

const navigateToField = option => {
  if (option) {
    window.location.hash = '';
    window.location.hash = `#${option.label}`;
    const tabContent = document.querySelector('.tab-content');
    const anchor = tabContent.querySelector(`[id="${option.label}"]`);
    if (anchor) {
      const tabPane = anchor.closest('.tab-pane');
      if (tabPane) {
        const tabLinkID = tabPane.id.replace('tabpane', 'tab');
        const tabLink = document.getElementById(tabLinkID);
        tabLink?.click();
        setTimeout(() => {
          const formcontrol = anchor.querySelector('[id]');
          formcontrol?.focus();
        }, 1);
      }
    }
  }
};

const FormSearchBar = () => {
  const formSearchOptions = useSelector(selectFormSearchOptions);
  const memoSearchOptions = useMemo(() => formSearchOptions, [formSearchOptions]);

  return (
    <div className="form-group">
      <Select
        cacheOptions
        className="react-select-container"
        classNamePrefix="react-select"
        components={{ DropdownIndicator }}
        formatGroupLabel={formatGroupLabel}
        isClearable
        isSearchable
        onChange={navigateToField}
        openMenuOnClick={false}
        options={memoSearchOptions}
        placeholder="Search for field"
        aria-label="Search for field"
        styles={{ dropdownIndicator: css => ({ ...css, padding: 0 }), clearIndicator: css => ({ ...css, padding: 0 }) }}
      />
    </div>
  );
};

export default FormSearchBar;
